import { Stack } from 'src/design/atoms/Stack';
import React from 'react';
import { ConversationsTable } from 'src/routes/Settings/AIAssistant/components/ConversationsTable';
import { DateRangeFilter } from 'src/routes/Settings/AIAssistant/components/DateRangeFilter';
import { useDefaultDateRange } from 'src/routes/Settings/AIAssistant/hooks/useDefaultDateRange';

export const ConversationsTab: React.FC = () => {
  const [dateRange, setDateRange] = useDefaultDateRange();

  return (
    <Stack>
      <DateRangeFilter value={dateRange} onChange={setDateRange} />
      <ConversationsTable dateRange={dateRange} />
    </Stack>
  );
};
